import type { BeforeRequestState } from 'ky';

/**
 * Logs details of an outgoing HTTP request to the console for debugging purposes.
 *
 * This function is intended to be used as a hook with the `ky` HTTP client library.
 * It logs the request URL and the associated options in a collapsed console group.
 *
 * @param {BeforeRequestState} param0 - An object containing the request and options.
 * @param {Request} param0.request - The outgoing HTTP request object.
 * @param {RequestInit} param0.options - The options used to configure the request.
 * @returns {Request | Response | undefined | Promise<Request | Response | undefined>}
 * Returns the original request object, or a promise resolving to it, as required by the ky hook signature.
 */

export const logRequest = ({
  options,
  request,
}: BeforeRequestState): Promise<Request | Response | undefined> | Request | Response | undefined => {
  console.groupCollapsed(`Request: ${request.url}`);
  console.dir(options);
  console.groupEnd();

  return request;
};
